// Embedded forms
export const STICKY_SIDEBAR = 'STICKY_SIDEBAR';
export const POLITE_SLIDE_IN = 'POLITE_SLIDE_IN';
export const POPUP = 'POPUP';
export const INLINE = 'INLINE';
// FORM LAYOUTS URLS
export const FORM_LAYOUT_URLS = {
	STICKY_SIDEBAR: 'https://stcdn.leadconnectorhq.com/forms/img/sticky-sidebar.png',
	POLITE_SLIDE_IN: 'https://stcdn.leadconnectorhq.com/forms/img/polite-slide-in.png',
	STICKY_SIDEBAR_RIGHT: 'https://stcdn.leadconnectorhq.com/forms/img/polite-slide-in-right.png',
	POLITE_SLIDE_IN_LEFT: 'https://stcdn.leadconnectorhq.com/forms/img/sticky-sidebar-left.png',
	POPUP: 'https://stcdn.leadconnectorhq.com/forms/img/popup-layout.png',
	INLINE: 'https://stcdn.leadconnectorhq.com/forms/img/inline-layout.png',
};
export const CARD_LAYOUTS = [
	{
		id: 'STICKY_SIDEBAR',
		image: FORM_LAYOUT_URLS.STICKY_SIDEBAR,
		name: 'Sticky sidebar',
		allowMinimize: false,
		minimizedTitle: '',
		isLeftAligned: true,
		isRightAligned: false,
		description:
			'A Sticky sidebar will appear on the side of the screen and can be minimized to a tab that sticks to the side of the window',
		hoverDescription: 'Appear on the side of the screen and can be minimized to a tab that sticks to the side of the window'
	},
	{
		id: 'POLITE_SLIDE_IN',
		image: FORM_LAYOUT_URLS.POLITE_SLIDE_IN,
		name: 'Polite slide-in',
		allowMinimize: false,
		minimizedTitle: '',
		isLeftAligned: false,
		isRightAligned: true,
		description:
			'A polite slide-in appears on the bottom side of screen and disappears once closed',
		hoverDescription: 'Appears on the bottom side of screen and disappears once closed'
	},
	{
		id: 'POPUP',
	  image: FORM_LAYOUT_URLS.POPUP,
		name: 'Popup',
		description: 'A pop-up shows form as an overlay inside a light-box. It cannot be minimized but closed.',
		hoverDescription: 'A pop-up shows form as an overlay inside a light-box. It cannot be minimized but closed.'
	},
	{
		id: 'INLINE',
		image: FORM_LAYOUT_URLS.INLINE,
		name: 'Inline',
		description: 'An inline form appears along with the content of the page as a native element. It does not overlay and cannot be closed or minimized.',
		hoverDescription: 'An inline form appears along with the content of the page as a native element. It does not overlay and cannot be closed or minimized.'
	},
];

export const TRIGGERS = [
	{ id: 'showOnScrolling', name: 'Show on scrolling', showInput: true },
	{ id: 'showAfter', name: 'Show after', showInput: true },
	{ id: 'alwaysShow', name: 'Always show', showInput: false },
];

export const ACTIVATION_OPTIONS = [
	{ id: 'activateOnVisit', name: 'Activate on', showInput: true },
	{ id: 'alwaysActivated', name: 'Always activated', showInput: false },
];

export const DEACTIVATION_OPTIONS =  [
	{
		id: 'deactivateAfter',
		name: 'Deactivate after showing',
		showInput: true,
	},
	{
		id: 'leadCollected',
		name: 'Deactivate once lead is collected',
		showInput: false,
	},
	{ id: 'neverDeactivate', name: 'Never deactivate', showInput: false },
];

export const AUTHORIZE_NET = 'authorize-net'
export const NMI = 'nmi'
export const STRIPE = 'stripe'
export const COURSES = 'courses'

export enum AttributionMediums { Manual = "manual", Conversation = "conversation" }
export enum AttributionSource { CrmUI ='CRM UI', Others = 'Other' }

export const STAR_SHIP_A_RECORD = '104.18.185.50'

export enum SHOP_STATE { PENDING_ON_YEXT = 'PENDING_ON_YEXT', ACCOUNT_CREATION = 'ACCOUNT_CREATION', YEXT_PAYMENT = 'YEXT_PAYMENT', PITCH = 'PITCH' }

export enum STRIPE_STATUS { UNSUBSCRIBED = 'UNSUBSCRIBED', COMPLETE = 'COMPLETE', UNSUBSCRIBED_STRIPE = 'UNSUBSCRIBED_STRIPE' }

export const YEXT_AVAILABLE_IN_COUNTRIES = ['US', 'GB', 'CA', 'AU']

export enum YEXT_PUBLISHER_AS_PER_COUNTRY  {
  US = 95,
  GB = 55,
  CA = 52,
  AU = 35
}

export const CONTACT_MENU_ROUTES = ['smart-list-settings-v2', 'business-v2', 'tasks-v2', 'contact_restore-v2', 'bulk-actions-log-v2', 'smart-list-v2']
export const IP_PRODUCT_ID = 'EmailIP'

export const GHL_AGENCIES = ["Ydk7Yx1VsHhacT39iE4Z", "YuTUZlUtrwBtvmgByZDW",
  "7AqLe6z8gDUQ0UOsKqjs",
  "lcsPwMCbJCzJ6uyUNLuK",
  "NEee0aZemVG3jhJGNJU7",
  "ONgR8E3n3wZ4cBKf6FVo",
  "VhWbPvpo398vLlfgpeJS",
  "MPhNgkgD7s4lPo3zecZV",
  "ALWGvtCE3rXmbRmp3HFu",
  "J8w1JIkbcw0noPMv8WVg",
  "Tb9sbAynupiTmvJmAxqR",
  "zM6nbAiAmaW69QX7Esr1",
  "jy9XQfjclOH81LmEHZV4",
  "OrvVN9WX7GLZEUZVZ0Bt",
  "H2vD1Jadzdh7jZwffalu",
  "jobtSAv9Qcp0wwIsvQMg",
  "5nCXKUO7daRBUegGQgcD",
  "At9zzlbcC32qQPHA5dmG",
  "YXwGqfSPP2aBzlYyQO9l",
  "E1RU4wSZeuxWwhrDuf2F",
  "pY1jBNrc8M0wWFogOR41",
  "eU1TXfLtXufTqYByoFme",
  "RKwvwWPGHUv4CnEK8O6C",
  "7Xk8HO7P2ENC3mtur9fH",
  "prKjtsHCmaxHJk73dzYO",
  "HA4jFDFaYhA78RFlTySF",
  "LUILz7qZQq6d1x24ggkn",
  "dKrTaLGtnkgJmDDK1lB6",
  "ocyDQblAozXMqCJrfrUK",
  "YDWuYdL1oiUMjIi6jgo8",
  "p5hVwcmi08hfHx6SZFTJ",
  "PjQcVv7jMLcPxvO5qgnu"
];
export const PREMIUM_PLAN_STARTING_PRICE = 497
